import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() { return ["select"]; }
  static get values() { return { url: String }; }

  change() {
    // Not an open redirect, so no same-origin assertion here: `urlValue` is
    // `switch_account_organization_path`, a Rails route helper rendered server-side, so the
    // destination is always a same-origin relative path and never comes from a response body.
    // The slug still gets encoded - it reaches a query string, where a bare `&` or `#` would
    // otherwise inject a parameter.
    const team = encodeURIComponent(this.selectTarget.value);
    window.location.href = `${this.urlValue}?team=${team}`;
  }
}
